import { Icon } from "@iconify/react";
import React, { useMemo, useState } from "react";
import "./index.css";
import { OverlayTrigger, Tooltip } from "react-bootstrap";

export function GraficoPesquisaSatisfacao({dados, periodo, height="auto"}){
  const [mediaConvertida, setMediaConvertida] = useState("0");

  const respostas = useMemo(()=>{
    return Object.keys(dados?.respostas).sort((a, b)=>{
           if(dados?.respostas[a]?.peso > dados?.respostas[b]?.peso){
                return 1
            }else if(dados?.respostas[a]?.peso < dados?.respostas[b]?.peso){
                return -1
            }else{
                return 0;
            }
        }).map((key)=>{
          return dados?.respostas[key];
        });
  },[dados])

  const resolvendoEmojiNota = useMemo(()=>{
    const minOriginal = respostas[0].peso ?? 0;
    const maxOriginal = respostas[respostas?.length - 1].peso ?? 0;
    const minNovo = dados?.escala?.minimo ?? 0;
    const maxNovo = dados?.escala?.maximo ?? 5;
    let normalizado = (Number(dados?.media) - minOriginal) / (maxOriginal - minOriginal);

    let notaConvertida = parseFloat(normalizado * (maxNovo - minNovo) + minNovo);
    setMediaConvertida(notaConvertida.toFixed(2).replace('.', ','));
    
    if(notaConvertida >= 0 && notaConvertida < 1){
      return <Icon icon="noto:angry-face" className="icon-resultado"/>
    }else if(notaConvertida >= 1 && notaConvertida < 2){
      return <Icon icon={"noto:frowning-face"} className="icon-resultado"/>
    }else if(notaConvertida >= 2 && notaConvertida < 3){
      return <Icon icon={"noto:confused-face"} className="icon-resultado"/>
    }else if(notaConvertida >= 3 && notaConvertida < 4){
      return <Icon icon={"noto:expressionless-face"} className="icon-resultado"/>
    }else if(notaConvertida >= 4 && notaConvertida < 5){
      return <Icon icon={"noto:smiling-face"} className="icon-resultado"/>
    }else if(notaConvertida >= 5){
      return <Icon icon="noto:beaming-face-with-smiling-eyes" className="icon-resultado"/>
    }
    
  },[dados, respostas])

  return (
    <div className="grafico-pesquisa-publica" style={{height: height ?? "auto"}}>
      <div><span>Período: {periodo ?? ""}</span></div>
      <div className="info-section">
        <div className="nota-section">
          {resolvendoEmojiNota}
         <OverlayTrigger
              key="iconCopy"
              placement="top"
              overlay={
                  <Tooltip
                      id={"qr-code-publico"}
                  >
                      Nota de 0 a 5
                  </Tooltip>
              }
          >
            <div className="valor-nota">Média: { dados?.total_respostas ? mediaConvertida : 0}</div>
          </OverlayTrigger>
          <div className="section-total-respostas">
            <span>Total de resposta: <b>{dados?.total_respostas ?? 0}</b> ({dados?.total_respostas ? ((dados?.total_respostas/dados?.total) * 100).toFixed(2).replace('.', ',') : 0}%)</span>
            <span>Pesquisa enviadas: <b>{dados?.total ?? 0}</b></span>
          </div>
        </div>
        <div className="respostas-section">
          {respostas.map((item, index)=>{
            return(
              <div key={index} className="resposta"><span className="badge-quantidade">{item?.quantidade ?? 0}</span> {item?.label} </div>
            )
          })}
        </div>
      </div>
    </div>
  )
}
